export const managementData = {
  leadership2025: [
    { 
      name: 'Pablo Azevedo', 
      role: 'Presidente', 
      photo: '/media/team/pablo-azevedo.png', 
      linkedin: 'https://www.linkedin.com/in/pabloazevedo/' 
    },
    { 
      name: 'Laura Rodrigues', 
      role: 'Vice-Presidente de Negócios', 
      photo: '/media/team/laura-rodrigues.png', 
      linkedin: 'https://www.linkedin.com/in/laura-rodrigues31/' 
    },
    { 
      name: 'Cecília Galvão', 
      role: 'Vice-Presidente de Tecnologia', 
      photo: '/media/team/cecilia-galvao.png', 
      linkedin: 'https://www.linkedin.com/in/ceciliagalvaoo/' 
    },
  ],
  productOwners: [
    { name: 'Caio Alcantara', photo: '/media/team/caio-alcantara.png', linkedin: 'https://www.linkedin.com/in/caio-alcantara-santos/' },
    { name: 'Yasmim Passos', photo: '/media/team/yasmim-passos.png', linkedin: 'https://www.linkedin.com/in/yasmim-passos/' },
    { name: 'Marcelo Rossignolli', photo: '/media/team/marcelo-rossignolli.png', linkedin: 'https://www.linkedin.com/in/marcelo-rossignolli/' },
  ],
  directors: [
    {
      name: 'Amanda Rosa',
      role: 'Diretora de Marketing',
      photo: '/media/team/amanda-rosa.png',
      linkedin: 'https://www.linkedin.com/in/amandadarosa/',
      coordinators: [
        { name: 'Lavínia Mendonça', role: 'Coordenadora de Marketing', photo: '/media/team/lavinia-mendonca.png', linkedin: 'https://www.linkedin.com/in/lavinia-mendonca/' },
        { name: 'Eduardo Casarini', role: 'Coordenador de Marketing', photo: '/media/team/eduardo-casarini.png', linkedin: 'https://www.linkedin.com/in/eduardo-casarini/' },
      ],
    },
    {
      name: 'Débora Nogueira',
      role: 'Diretora Administrativa',
      photo: '/media/team/debora-nogueira.png',
      linkedin: 'https://www.linkedin.com/in/debora-pereira-nogueira/',
    },
    {
      name: 'Raiane Brandão',
      role: 'Diretora de Estratégia',
      photo: '/media/team/raiane-brandao.png',
      linkedin: 'https://www.linkedin.com/in/raianearaujobrandao/',
      coordinators: [
        { name: 'Stefanne Soares', role: 'Coordenadora de Estratégia', photo: '/media/team/stefanne-soares.png', linkedin: 'https://www.linkedin.com/in/stefannesoares/' },
        { name: 'Guilherme Hassenpflug', role: 'Coordenador de Estratégia', photo: '/media/team/guilherme-hassenpflug.png', linkedin: 'https://www.linkedin.com/in/guilherme-hassenpflug-644ba4342/' },
      ],
    },
    {
      name: 'Marcelo Rossignolli',
      role: 'Diretor de Mercado',
      photo: '/media/team/marcelo-rossignolli.png',
      linkedin: 'https://www.linkedin.com/in/marcelo-rossignolli/',
    },
  ],
  founders: [
    { name: 'Pablo Azevedo', photo: '/media/team/pablo-azevedo.png', linkedin: 'https://www.linkedin.com/in/pabloazevedo/' },
    { name: 'Cecília Galvão', photo: '/media/team/cecilia-galvao.png', linkedin: 'https://www.linkedin.com/in/ceciliagalvaoo/' },
    { name: 'Laura Rodrigues', photo: '/media/team/laura-rodrigues.png', linkedin: 'https://www.linkedin.com/in/laura-rodrigues31/' },
  ],
  leadership2026: [
    { 
      name: 'Amanda Rosa', 
      role: 'Presidente', 
      photo: '/media/team/amanda-rosa.png', 
      linkedin: 'https://www.linkedin.com/in/amandadarosa/' 
    },
    { 
      name: 'Stefanne Soares', 
      role: 'Vice-Presidente de Negócios', 
      photo: '/media/team/stefanne-soares.png', 
      linkedin: 'https://www.linkedin.com/in/stefannesoares/' 
    },
    { 
      name: 'Guilherme Hassenpflug', 
      role: 'Vice-Presidente de Tecnologia', 
      photo: '/media/team/guilherme-hassenpflug.png', 
      linkedin: 'https://www.linkedin.com/in/guilherme-hassenpflug-644ba4342/' 
    },
  ],
  productOwners26: [
    { name: 'Reimar Filho', photo: '/media/team/reimar-filho.png', linkedin: 'https://www.linkedin.com/in/reimar-filho/' },
    { name: 'Tobias Viana', photo: '/media/team/tobias-viana.png', linkedin: 'https://www.linkedin.com/in/tobias-viana/' },
    { name: 'Paulo Bueno', photo: '/media/team/paulo-bueno.png', linkedin: 'https://www.linkedin.com/in/paulo-henrique0601/' },
    { name: 'Matheus Silva', photo: '/media/team/matheus-silva.png', linkedin: 'https://www.linkedin.com/in/matheus-silva-09b0a020b/' },
  ],
  directors26: [
    {
      name: 'Lavínia Mendonça',
      role: 'Diretora de Marketing',
      photo: '/media/team/lavinia-mendonca.png',
      linkedin: 'https://www.linkedin.com/in/lavinia-mendonca/',
      coordinators: [
        { name: 'Vitor Ribeiro', role: 'Coordenador de Comunicação', photo: '/media/team/vitor-ribeiro.png', linkedin: 'https://www.linkedin.com/in/vitor-ribeiro-ms/' },
        { name: 'Yasmin Pinho', role: 'Coordenadora de Conteúdo', photo: '/media/team/yasmin-pinho.png', linkedin: 'https://www.linkedin.com/in/yasmin-pinho-1112413a9/' },
        { name: 'Anita Fratelli', role: 'Coordenadora de Conteúdo', photo: '/media/team/anita-fratelli.png', linkedin: 'https://www.linkedin.com/in/anita-fratelli-258398314/' },
      ],
    },
    {
      name: 'Débora Nogueira',
      role: 'Diretora Administrativa',
      photo: '/media/team/debora-nogueira.png',
      linkedin: 'https://www.linkedin.com/in/debora-pereira-nogueira/',
      coordinators: [
        { name: 'Isabella Santos', role: 'Coordenadora Administrativa', photo: '/media/team/isabella-santos.png', linkedin: 'https://www.linkedin.com/in/vitor-ribeiro-ms/' },
      ],
    },
    {
      name: 'Isabela Teixeira',
      role: 'Diretora de Estratégia',
      photo: '/media/team/isabela-teixeira.png',
      linkedin: 'https://www.linkedin.com/in/isabelatcoldibella/',
    },
    /*
    {
      name: 'Yuri Boczar',
      role: 'Diretor de Mercado',
      photo: '/media/team/yuri-boczar.png',
      linkedin: 'https://www.linkedin.com/in/yuriboczar/',
    },
    */
  ],
};